var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 19,
    viewBox: "0 0 11 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.85838 9.60174L9.99938 2.18174C10.1281 2.05131 10.2002 1.87546 10.2002 1.69224C10.2002 1.50902 10.1281 1.33317 9.99938 1.20274C9.93611 1.13849 9.86069 1.08747 9.77751 1.05264C9.69433 1.01781 9.60505 0.999878 9.51488 0.999878C9.4247 0.999878 9.33543 1.01781 9.25225 1.05264C9.16907 1.08747 9.09365 1.13849 9.03038 1.20274L1.20038 9.11074C1.07171 9.24117 0.999563 9.41702 0.999563 9.60024C0.999563 9.78346 1.07171 9.95931 1.20038 10.0897L9.03038 17.9977C9.09365 18.062 9.16907 18.113 9.25225 18.1478C9.33543 18.1827 9.4247 18.2006 9.51488 18.2006C9.60505 18.2006 9.69433 18.1827 9.77751 18.1478C9.86069 18.113 9.93611 18.062 9.99938 17.9977C10.1281 17.8673 10.2002 17.6915 10.2002 17.5082C10.2002 17.325 10.1281 17.1492 9.99938 17.0187L2.85838 9.60174Z",
    fill: "black",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftIcon);
export default __webpack_public_path__ + "static/media/left-icon.6cde1accd9eb02022e015a4f055cc6de.svg";
export { ForwardRef as ReactComponent };